// extracted by mini-css-extract-plugin
export default {"todo":"Todo_todo__qPR59","todoDelete":"Todo_todoDelete__gKTF7","todoChekbox":"Todo_todoChekbox__fDSKS","completedTodo":"Todo_completedTodo__1IekK"};